import { createBrowserRouter, RouterProvider } from "react-router-dom";
import MainLayout from "../layout/MainLayout";
import ProtectedRoute from "../components/ProtectedRoute";
import SessionWarning from "../components/SessionWarning";

// Pages
import LoginPage from "../pages/Auth/LoginPage";
import HomePage from "../pages/Home/HomePage";
import CustomersPage from "../pages/Customers/CustomersPage";
import AddItem from "../pages/AddItem/AddItem";
import SupplierPage from "../pages/Suppliers/SupplierPage";
import TransactionHistory from "../pages/CustomerTransactionHistory/TransactionHistory";
import InventoryPage from "../pages/Inventory/InventoryPage";
import CustomerTransaction from "../pages/CreateCustomerTransaction/CustomerTransaction";
import CustomerLedger from "../pages/CustomerLedger/CustomerLedger";
import SupplierTransactionForm from "../pages/SupplierTransaction/SupplierTransactionForm";
import SupplierLedger from "../pages/SupplierLedger/SupplierLedger";
import AddGirvi from "../pages/Girvi/AddGirvi";
import ViewGirvi from "../pages/Girvi/ViewGirvi";
import GirviPayment from "../pages/Girvi/GirviPayment";
import GirviLedger from "../pages/Girvi/GirviLedger";
import Roznama from "../pages/Roznama/Roznama";
import SupplierTransactionHistory from "../pages/SupplierTransactionHistory/SupplierTransactionHistory";
import SubscriptionPage from "../components/SubscriptionPage";
// import RegistrationPage from "../pages/Auth/RegistrationPage";
import Profile from "../components/Profile";
import StockTransactionReport from "../pages/StockTransactionReport/StockTransactionReport";
import StockVerification from "../components/StockVerification/StockVerification";
import SchemeCardPage from "../pages/SchemeCard/SchemeCardPage";
import AdvancePaymentManagement from "../pages/AdvancePaymentManagement/AdvancePaymentManagement";
import URDPurchase from "../pages/URDPurchase/urdPurchase";

const router = createBrowserRouter([
  {
    path: "/login",
    element: <LoginPage />,
  },
  // {
  //   path: "/RegistrationPage",
  //   element: <RegistrationPage />,
  // },
  {
    path: "/",
    element: (
      <>
        <SessionWarning /> {/* Add session warning */}
        <ProtectedRoute>
          <MainLayout />
        </ProtectedRoute>
      </>
    ),
    children: [
      {
        path: "",
        element: <HomePage />,
      },
      {
        path: "customers",
        element: <CustomersPage />,
      },
      {
        path: "customer-transactions",
        element: <TransactionHistory />
      },
      {
        path: "create-customer-transactions",
        element: <CustomerTransaction />
      },
      {
        path: "inventory",
        element: <InventoryPage />
      },
      {
        path: "addItem",
        element: <AddItem />,
      },
      {
        path: "supplier",
        element: <SupplierPage />,
      },
      {
        path: "customer-ledger",
        element: <CustomerLedger />,
      },
      {
        path: "supplier-transaction",
        element: <SupplierTransactionForm />,
      },
      {
        path: "supplier-transaction-history",
        element: <SupplierTransactionHistory />
      },
      {
        path: "roznama",
        element: <Roznama />,
      },
      {
        path: "supplier-ledger",
        element: <SupplierLedger />,
      },
      {
        path: "StockTransactionReport",
        element: <StockTransactionReport />
      },
      {
        path: "add-security-deposit",
        element: <AddGirvi />,
      },
      {
        path: "security-deposits",
        element: <ViewGirvi />,
      },
      {
        path: "security-deposit-ledger/:id",
        element: <GirviLedger />,
      },
      {
        path: "security-deposits-payment/:id",
        element: <GirviPayment />,
      },
      {
        path: "Profile",
        element: <Profile />
      },
      {
        path: "SubscriptionPage",
        element: <SubscriptionPage />
      },
      {
        path: "scheme-card",
        element: <SchemeCardPage />,
      },
      {
        path: "urd-purchase",
        element: <URDPurchase />,
      },
      {
        path: "stock-verification",
        element: <StockVerification />
      },
      {
        path: "advance-payment",
        element: <AdvancePaymentManagement />
      }
    ],
  },

  // Catch-all 404 route
  {
    path: "*",
    element: <LoginPage />, // or create a NotFound page
  },

  // Catch-all 404 route
  {
    path: "*",
    element: <LoginPage />, // or create a NotFound page
  },
]);

export default function AppRoutes() {
  return <RouterProvider router={router} />;
}